import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import * as serviceWorker from './serviceWorker';
// routing - URL Single Page
import { BrowserRouter } from 'react-router-dom';

// Aggiungi Middleware per eseguire le chiamate Async nel reducer
import thunk from 'redux-thunk';
// REDUX + middlewere per effettuare chiamate asyncrone nel reducer
import { createStore, applyMiddleware, compose, combineReducers } from 'redux'; // da aggiungere il Middleware e compose per eseguire le chiamate async nello store quindi nel reducer
import { Provider } from 'react-redux'; // includere tutta la <App> all'interno del Provider Componente
// import reducer from './reducers/Auth'; // Contiene la logica del reducer => se questo è solo un reducer, altrimenti su usa il combine Reducers per usare più reducers
import authReducer from './reducers/Auth';
import dbReducer from './reducers/Database';

// Configurazione middleware per chiamate asyncrone nel reducer
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// uso più reducers nella App, usando il componente combine reducers
const rootReducer = combineReducers({
    auth: authReducer,
    db: dbReducer // importo il reducer del DB
})
// configurazione Middlewere per effettuare chiamate asyncrone nel reducer
const store = createStore(rootReducer, composeEnhancers( // reducer
    applyMiddleware(thunk)
));
// END REDUX


ReactDOM.render(
    
        <BrowserRouter basename="/">
            <Provider store={store}>
                <App />
            </Provider>
        </BrowserRouter>
    
    ,document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
